export const BACKEND_DOMAIN = "https://sc-backend.store"
// export const BACKEND_DOMAIN = "http://localhost:5004"